module.exports = __webpack_public_path__ + "img/1.c6e8c223.svg";